module.exports = __webpack_public_path__ + "b14fefae17c76a1b95ee5a3f863aadac.pdf";